import blowmind from  "../assets/img/blowmind.png";
import { useState } from "react";
import water from "../assets/img/water.png";

export default function Calculator() {

   const [revenue, setRevenue] = useState(0);
   const [rechazadas, setRechazadas] = useState(0);
   const [totales, setTotales] = useState(0);
   const [rate, setRate] = useState(0);
   const [emoji,setEmoji] = useState(water);


  
   
   function showResult() {
     setRate((((revenue-rechazadas)/totales)*100).toFixed(2));
   }

   function showFace(){
      if(rate<30){
       setEmoji(water);}
        else{
           if(rate<50){
              setEmoji(blowmind);
           } else { 
                if (rate<90) {
                  setEmoji(blowmind);} 
                  else {
                     setEmoji(blowmind);}}}
                  }



   
    return (
      <main className="hidden md:block lg:relative">
        <div class="flex justify-left bg-gray-100">
            <div class="pl-24">
                <h1 className="py-2 text-6XL tracking-tight font-jakarta font-bold text-black bg-clip-text bg-gradient-to-r  sm:text-6xl pb-5 md:text-6xl text-5xl xl:text-6xl">
                 <span>How you doin'</span>
                </h1>
             <div class="mt-4 mb-6 xl:w-96">
                <label class="absolute right-1/3 w-96 block text-black mt-4 font-bold md:text-left  mb-1 md:mb-0 pr-4  " for="TotalOrders">Monthly dollar value of orders.
                 </label>
                 <input
                 value={totales}
                 onChange = {e=>{setTotales(e.target.value)}}
                 type="number"
                 class="form-control
                 block
                 w-full
                 h-24
                 px-3
                 py-1.5
                 text-base
                 font-normal
                text-gray-700
                bg-white bg-clip-padding
                border border-solid border-gray-300
                rounded-xl
                transition
                ease-in-out
                m-0
                shadow-2xl
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
                " 
                id="TotalOrders"
                placeholder="$0.00"
                 />
              </div>
              <div class="mb-6 xl:w-96">
                <label for="OrdersDeclined" class="absolute right-1/3 w-96 mt-4 block text-black font-bold md:text-left mb-1 md:mb-0 pr-4">Monthly dollar amount of charge backs.
                 </label>
                 <input
                 value={rechazadas}
                 onChange = {e=>{setRechazadas(e.target.value)}}
                 type="number"
                 class="form-control
                 block
                 w-full
                 h-24
                 px-3
                 py-1.5
                 text-base
                 font-normal
                text-gray-700
                bg-white bg-clip-padding
                border border-solid border-gray-300
                rounded-xl
                transition
                ease-in-out
                m-0
                shadow-2xl
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
                " 
                id="OrdersDeclined"
                placeholder="$0.00"
                 />
              </div>
             <div class="mb-6 xl:w-96">
                <label for="Revenue" class="absolute right-1/3 w-96 mt-4 block text-black font-bold md:text-left mb-1 md:mb-0 pr-4">Monthly dollar amount of orders approved (i.e., became actual revenue) each month.
                 </label>
                 <input
                 value={revenue}
                 onChange = {e=>{setRevenue(e.target.value)}}
                 type="number"
                 class="form-control
                 block
                 w-full
                 h-24
                 px-3
                 py-1.5
                 text-base
                 font-normal
                text-gray-700
                bg-white bg-clip-padding
                border border-solid border-gray-300
                rounded-xl
                transition
                ease-in-out
                m-0
                shadow-2xl
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
                " 
                id="Revenue"
                placeholder="$0.00"
                 />
                
             </div>
             <div class="w-96">
             <button onClick={()=>{
               showResult();
               setEmoji(blowmind);
             }} type="button" class="inline-block 
             px-6 py-2.5
             w-Full
             h-20
             bg-black text-white 
             font-medium text-xs leading-tight uppercase rounded-xl shadow-md
             active:bg-white active:text-black hover:shadow-lg  transition duration-150 ease-in-out
             active:shadow-lg">
                Calculate approval rate</button>
              </div>
             </div>
             <div id="Result" className="absolute right-10 w-96 mt-24 object-center ">
             <h1 className="py-2 text-3xl tracking-tight text-center font-jakarta font-bold text-black bg-clip-text bg-gradient-to-r  sm:text-6xl pb-5 md:text-6xl  xl:text-5xl ">
                Your approval rate is...</h1>
                {/* <div aria-hidden="true" className="flex justify-center items-center">
                    <svg class="flex object-center mr-2 w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                        </svg>
                        <span class="sr-only">Loading...</span>
                        </div> */}
             <div className="pt-8 text-center text-3xl tracking-tight font-jakarta font-bold text-black bg-clip-text bg-gradient-to-r  sm:text-6xl pb-5 md:text-6xl  xl:text-5xl">
                <h1>{rate}%</h1>
             </div>
                <div id="myDIV" className="flex justify-center  lg:flex-1">
                        <img className="center w-40 h-30"
                            src={emoji} alt="emoji"></img>
                    </div>
             
           </div>
           
           
         </div>
          

         </main>
    );
}